import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { ServerRequestProtected } from '../../../../../../../../../../../utils/ServerDataRequest';
import NotificationHandler from '../../../../../../../../../../../utils/NotificationHandler';
import FormValidator from '../../../../../../../../../../../utils/FormValidator';
import { Dropdown, Modal } from "react-bootstrap";
import DatePicker from '../../../../../../../../../../General/DatePicker';
import ModalHeader from '../../../../../../../../../../Setup/Shared/ModalHeader';
import Nav from "react-bootstrap/Nav";
import SuperSearchList from '../../../../../../../../../../shared/SuperSearch/SuperSearchList';
import DeleteConfirmatiom from '../../../../../../../../../../General/DeleteConfirmation';
import isNull from '../../../../../../../../../../../utils/NullChecking';
import { enumUtil } from '../../../../../../../../../../../utils/Enum';
import Loader from '../../../../../../../../../../shared/Loader/Loader';
import DropdownValueHandler from '../../../../../../../../../../shared/SuperSearch/DropdownValueHandler';
import { DrugAllergies, EnvironmentalAllergies, FoodAllergies, ReactionData } from '../../../../../../../../../../../utils/Constants';
import SuperSearchMultipleClient from '../../../../../../../../../../shared/SuperSearch/MultipleSelection/SuperSearchMultipleClient';
const SeverityData = [
    { display: 'Mild', value: 'Mild' },
    { display: 'Moderate', value: 'Moderate' },
    { display: 'Severe', value: 'Severe' },
    { display: 'Very Mild', value: 'VeryMild' },
];

const StatusData = [
    { display: 'Active', value: 'true' },
    { display: 'InActive', value: 'false' },
];
const AddNewAllergies = (props) => {
    const { isOpenAllergies, onClose, onDeleteAllergies, patientID, IsEditAllowed } = { ...props }
    const API_URL = enumUtil.controller.General
    let Allergies_Modal = {
        PatientID: patientID + "",
        AllergyType: "Drug",
        AllergyName: "",
        Reaction: "",
        OnSetDate: "",
        Severity: "",
        OnSet: "",
        AllergyStatus: "",
        ColorCode: "",
        Notes: "",
    }
    let valModal = {}
    let ValidationModal = {
        ReactionVal: "",
        AllergyNameVal: "",
        StatusVal: "",
    }
    const [isOpenDeleteAlert, setisOpenDeleteAlert] = useState(false);
    const [isEdit, setIsEdit] = useState(true)
    const [allergiesID, setAllergiesID] = useState();
    const [allergiesValidationModal, setAllergiesValidationModal] = useState(ValidationModal)
    const [allergiesSaveUpdateModal, setAllergiesSaveUpdateModal] = useState({})
    const [mainAllergiesModal, setMainAllergiesModal] = useState(Allergies_Modal);
    const [isLoading, setIsLoading] = useState(false)
    const [onAllergiesSaved, setOnAllergiesSaved] = useState(false)
    const [del, setDel] = useState(false)
    const [searchDropdown, setSearchDropdown] = useState(false);
    const [is, setIs] = useState(false);
    const [allergyBody, setAllergyBody] = useState({
        "TableName": enumUtil.enumAPITableName.AllergyName,
        "SearchCriteria": {
            "AllergyType": mainAllergiesModal.AllergyType,
            "Search": null
        }
    })
    const [reloadSuperSearch, setReloadSuperSearch] = useState(false);

    const [multiSelectInitial, setMultiSelectInitial] = useState({
        ReactionInitails: [],
    })
    const makeArrayFromCommaSeparated = (values = '') => {
        if (isNull(values)) return [];

        return values.split(',').map(item => ({
            value: item.trim(),
            display: item.trim()
        }));
    };
    useEffect(() => {
        if (props.allergiesID != null) {
            setDel(true)
            setAllergiesID(props.allergiesID)
        } else {
            if (!onAllergiesSaved) {
                setAllergiesID(0);
                setDel(false)
            } else {
                setDel(true)
            }
        }
        if (!isNull(allergiesID)) {
            setIsLoading(true)
            ServerRequestProtected(API_URL + "/FindByID", 'post', {
                "ID": allergiesID,
                "TableName": enumUtil.enumAPITableName.PatientAllergy
            }).then((response) => {
                setIsLoading(false)
                setIs(true)
                response.AllergyStatus = DropdownValueHandler(StatusData, response.AllergyStatus)
                response.PatientID = response.PatientID + ""
                setMainAllergiesModal(response);
                setIsEdit(false);
                setReloadSuperSearch(!reloadSuperSearch)
                setMultiSelectInitial(prevState => ({
                    ...prevState,
                    ReactionInitails: makeArrayFromCommaSeparated(response.Reaction)
                }))
                setAllergiesSaveUpdateModal({ ...allergiesSaveUpdateModal, Reaction: response.Reaction });
            }).catch((error) => {
                NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
                setIsLoading(false)
            })
        }
    }, [allergiesID])
    const AllergiesValidation = async () => {
        let ValidationModal = {
            ReactionVal: FormValidator(
                allergiesSaveUpdateModal.Reaction,
                // mainAllergiesModal.Reaction,
                enumUtil.enumValidationType.Required,
                'Reaction Name',
            ),
            AllergyNameVal: FormValidator(
                mainAllergiesModal.AllergyName,
                enumUtil.enumValidationType.Required,
                'Severity',
            ),
            // ...(mainAllergiesModal.OnSet ? {} : {
            //     OnSetDateVal: FormValidator(
            //         mainAllergiesModal.OnSetDate,
            //         enumUtil.enumValidationType.Required,
            //         'OnSetDate',
            //     )
            // }),
            StatusVal: FormValidator(
                mainAllergiesModal.AllergyStatus,
                enumUtil.enumValidationType.Required,
                'Status',
            ),

        }
        await setAllergiesValidationModal(ValidationModal)
        valModal = ValidationModal
    }
    const handleSaveAllergies = async (type) => {
        await AllergiesValidation()
        let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck)
        if (validation) {
            NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
            return
        } else {
            setAllergiesSaveUpdateModal(allergiesSaveUpdateModal)
            let saveModal = {
                TableName: enumUtil.enumAPITableName.PatientAllergy,
                ID: allergiesID,
                Data: { PatientID: patientID + "", ...allergiesSaveUpdateModal },
            }
            setIsLoading(true)
            ServerRequestProtected(API_URL + "/SaveSingleRecord", 'post', saveModal)
                .then((response) => {
                    if (!isNull(response.id)) {
                        setIsLoading(false)
                        NotificationHandler(`Record Saved Successfully`, enumUtil.enumtoaster.success)
                        props?.setIsRecordSaved(true);
                        setAllergiesID(response.id)
                        setOnAllergiesSaved(true)
                        if (type === "Add Another") {
                            addNewAllergy();
                        } else {
                            onClose();
                        }
                    }
                }).catch((error) => {
                    setIsLoading(false)
                    console.log('error', error);
                    NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
                })
        }
    }
    const addNewAllergy = () => {
        props.setAllergiesID(null);
        setAllergiesID(null)
        handleClear();
    }
    const handleClear = () => {
        setMainAllergiesModal(Allergies_Modal);
        setAllergiesSaveUpdateModal({});
    }
    const handleSetCheckbox = (e) => {
        let { name, checked } = e.target
        let modal = { ...mainAllergiesModal };
        let saveModal = { ...allergiesSaveUpdateModal }
        modal[name] = String(checked);
        setMainAllergiesModal(modal)
        for (var property in Allergies_Modal) {
            if (name === property) {
                saveModal[name] = String(checked);
            }
        }
        setAllergiesSaveUpdateModal(saveModal)
    }
    const handleChange = (e) => {
        setIs(false);
        let { name, value } = e.target
        let modal = { ...mainAllergiesModal };
        let saveModal = { ...allergiesSaveUpdateModal }
        if (name === "AllergyType") {
            modal['AllergyName'] = ""
            saveModal['AllergyName'] = ""
        }
        modal[name] = value
        setMainAllergiesModal(modal)
        for (var property in Allergies_Modal) {
            if (name === property) {
                saveModal[name] = value
            }
        }
        setAllergiesSaveUpdateModal(saveModal)
    }
    const handleChangeDropdown = (e) => {
        setIs(false);
        let { name, value } = e.target
        let modal = { ...mainAllergiesModal };
        modal[name] = value
        setMainAllergiesModal(modal)
        setAllergyBody({
            ...allergyBody,
            SearchCriteria: {
                AllergyType: mainAllergiesModal.AllergyType,
                Search: value
            }
        })
    }
    const handleDateChange = (date, type) => {
        var FormatedDate = date
        let modal = { ...mainAllergiesModal };
        let saveModal = { ...allergiesSaveUpdateModal }
        modal[type] = FormatedDate
        setMainAllergiesModal(modal)
        for (var property in Allergies_Modal) {
            if (type === property) {
                saveModal[type] = FormatedDate
            }
        }
        setAllergiesSaveUpdateModal(saveModal)
    }
    const handleSelectedData = (selectedData, name, type, mode) => {
        setIs(true)
        let modal = { ...mainAllergiesModal };
        let SaveModal = { ...allergiesSaveUpdateModal };
        if (type === 'client' && !isNull(selectedData)) {
            modal[name] = selectedData.display
            SaveModal[name] = selectedData.value + "";
        } else if (type === 'server' && !isNull(selectedData)) {
            modal[name] = selectedData.display
            SaveModal[name] = selectedData.value + "";
        } else {
            modal[name] = ''
            SaveModal[name] = ''
        }
        setMainAllergiesModal(modal)
        setAllergiesSaveUpdateModal(SaveModal)
        return selectedData
    }
    const AllergiesName = () => {
        return (
            <p className="heading">Add New Allergy</p>
        )
    }
    const handleDeleteModal = () => {
        setisOpenDeleteAlert(true)
    }
    const onCloseDelete = () => {
        setisOpenDeleteAlert(false);
    }
    const onDelete = () => {
        props?.setIsRecordSaved(true);
        setisOpenDeleteAlert(false);
        onClose();
    }
    let DeleteConfirmation = "";
    if (isOpenDeleteAlert) {
        DeleteConfirmation = (
            <DeleteConfirmatiom
                isOpenAlert={isOpenDeleteAlert}
                hideReason={true}
                API_URL={API_URL}
                TableName={enumUtil.enumAPITableName.PatientAllergy}
                ID={allergiesID}
                onCloseDelete={onCloseDelete}
                onClose={onDelete}
            />
        );
    }
    let DeletePopup = "";
    if (del) {
        DeletePopup = (
            <button
                className={
                    props?.IsDeleteAllowed
                        ?
                        "btn-icon-transparent"
                        :
                        "btn-icon-transparent delete-btn-disabled"
                } onClick={handleDeleteModal}>
                <span className="icon"><i className="icon-delete"></i></span>
                <span className="title">Delete</span>
            </button>
        );
    }
    const getDrugDropDown = () => {
        if (mainAllergiesModal.AllergyType === 'Drug') {
            return DrugAllergies
        } else if (mainAllergiesModal.AllergyType === 'Food') {
            return FoodAllergies
        } else if (mainAllergiesModal.AllergyType === 'Environment') {
            return EnvironmentalAllergies
        } else {
            return []
        }
    }
    return (
        <Modal show={isOpenAllergies} onHide={isOpenAllergies} backdrop="static" keyboard={false} centered dialogClassName="hk-modal-v1 ar_ehr_problems ar_new-popup-design">
            {isLoading ? <Loader /> : null}
            <Modal.Body>
                {DeleteConfirmation}
                <ModalHeader HideAuditIcon={"PatEncounter"} HeaderName={AllergiesName} isOpenDeleteAlert={isOpenDeleteAlert} onCloseDelete={onCloseDelete} DeletePopup={DeletePopup} isClosed={onClose} />
                <div className="pt-2 add_block_appointment w-100">
                    <div className='patient_payment_tabs'>
                        <div className='ms-0'>
                            <Nav variant="tabs"
                                className="d-flex border-0 gx-0"
                                activeKey={mainAllergiesModal.AllergyType} >
                                <Nav.Item className="ar-copay-link ar-pad">
                                    <Nav.Link
                                        eventKey="Drug"
                                        className="text"
                                        onClick={() => handleChange({ target: { name: 'AllergyType', value: 'Drug' } })}
                                    >
                                        Drug
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item className="ar-copay-link ar-pad">
                                    <Nav.Link
                                        eventKey="Food"
                                        className="text"
                                        onClick={() => handleChange({ target: { name: 'AllergyType', value: 'Food' } })}
                                    >
                                        Food
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item className="ar-copay-link ar-pad">
                                    <Nav.Link
                                        eventKey="Environment"
                                        className="text"
                                        onClick={() => handleChange({ target: { name: 'AllergyType', value: 'Environment' } })}
                                    >
                                        Environment
                                    </Nav.Link>
                                </Nav.Item>
                            </Nav>
                        </div>
                        <div className="">
                            <div className={`input my-2 ${allergiesValidationModal.AllergyNameVal ? 'error' : ''}`}>
                                <div className='input-group hk-input-search'>
                                    <SuperSearchList
                                        type='client'
                                        id='AllergyName'
                                        name='AllergyName'
                                        searchValue={mainAllergiesModal.AllergyName}
                                        data={getDrugDropDown}
                                        // ApiLink={API_URL + "/DropDown"}
                                        method='post'
                                        // postBody={allergyBody}
                                        onChange={handleChangeDropdown}
                                        getSelectedData={handleSelectedData}
                                        is={is}
                                        sup_btn='sup_btn-Inp'
                                        sup_inp='superSearchVisitInp'
                                        placeholder={`Search ${mainAllergiesModal.AllergyType} here...`}
                                        inputError={allergiesValidationModal.AllergyNameVal}
                                    />
                                    {allergiesValidationModal.AllergyNameVal}
                                </div>
                            </div>
                            {/* <div className="mb-2 d-flex align-items-center justify-content-between gap-15 px-1">
                                <p className="text fs-13 font-m ar-dark-color validation_message text-nowrap"> <span className='text-decoration-underline'>Vitamin K Derivatives</span> <span className=''></span></p>
                                <i className='icon-edit-pencil fs-12'></i>
                            </div> */}
                            <div className="mb-12">
                                <div className="row m-0 align-items-center ">
                                    <div className="col-md-8 ar-sup ps-0 pateint-serach-no-rounded">
                                        <div className={`input autocomplete-group autocomplete-group-xs ${allergiesValidationModal.ReactionVal ? 'error' : ''}`}>
                                            <label htmlFor="" className="pb-3px">Reaction <span className='req'>*</span></label>
                                            <div className="input-group">
                                                <SuperSearchMultipleClient
                                                    key={reloadSuperSearch}
                                                    id='Reaction'
                                                    name='Reaction'
                                                    selectedOptionsDisplay='Reaction'
                                                    initialSelectedValues={multiSelectInitial.ReactionInitails}
                                                    searchParam={mainAllergiesModal}
                                                    setSearchParam={setAllergiesSaveUpdateModal}
                                                    options={ReactionData}
                                                    sup_btn="sup_btn-Inp"
                                                    sup_inp="superSearchVisitInp"
                                                />
                                                {allergiesValidationModal.ReactionVal}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-4 px-0">
                                        <div className="form-group input">
                                            <label className="pb-3px">Severity </label>
                                            <div className={`input form-group ar-multiple-br m-0`}>
                                                <SuperSearchList
                                                    type="client"
                                                    id='Severity'
                                                    name='Severity'
                                                    searchValue={mainAllergiesModal.Severity}
                                                    data={SeverityData}
                                                    onChange={handleChange}
                                                    getSelectedData={handleSelectedData}
                                                    is={is}
                                                    sup_btn='sup_btn-Inp'
                                                    sup_inp='superSearchVisitInp'
                                                    placeholder="Select type..."
                                                    // inputError={allergiesValidationModal.SeverityVal}
                                                />
                                                {/* {allergiesValidationModal.SeverityVal} */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="d-flex align-items-end gap-12 mb-12">
                                <div className={`input mb-0 `}>
                                    <label className="pb-3px">Onset Date {!isNull(mainAllergiesModal.OnSet) ? <span className='req'>*</span> : null}</label>
                                    <DatePicker
                                        className="mb-0"
                                        value={mainAllergiesModal.OnSetDate}
                                        handleCalendarChangefunc={date => handleDateChange(date, 'OnSetDate')}
                                    />
                                </div>
                                <div className={`form-group input ${allergiesValidationModal.StatusVal ? 'error' : ''}`}>
                                    <label className="pb-3px">Status <span className='req'>*</span></label>
                                    <div className={'input form-group ar-multiple-br m-0'}>
                                        <SuperSearchList
                                            type="client"
                                            id='AllergyStatus'
                                            name='AllergyStatus'
                                            searchValue={mainAllergiesModal.AllergyStatus}
                                            data={StatusData}
                                            onChange={handleChange}
                                            getSelectedData={handleSelectedData}
                                            is={is}
                                            sup_btn='sup_btn-Inp'
                                            sup_inp='superSearchVisitInp'
                                            placeholder="Select type..."
                                            inputError={allergiesValidationModal.StatusVal}
                                        />
                                    </div>
                                    {allergiesValidationModal.StatusVal}
                                </div>
                                {/* <div className="d-flex align-items-center gap-15">
                                    <div className="ar_radio-btn d-flex align-items-center gap-6">
                                        <input
                                            type="radio"
                                            id="Childhood"
                                            name="OnSet"
                                            value="Childhood"
                                            onChange={handleChange}
                                            checked={mainAllergiesModal.OnSet === "Childhood"}

                                        />
                                        <label htmlFor="Childhood" className="text ar-orange-text">Childhood</label>
                                    </div>
                                    <div className="ar_radio-btn d-flex align-items-center gap-6 ">
                                        <input
                                            type="radio"
                                            id="Adulthood"
                                            name="OnSet"
                                            value="Adulthood"
                                            onChange={handleChange}
                                            checked={mainAllergiesModal.OnSet === "Adulthood"}
                                        />
                                        <label htmlFor="Adulthood" className="text ar-orange-text">Adulthood</label>
                                    </div>
                                    <div className="ar_radio-btn d-flex align-items-center gap-6">
                                        <input
                                            type="radio"
                                            id="Unknown"
                                            name="OnSet"
                                            value="Unknown"
                                            onChange={handleChange}
                                            checked={mainAllergiesModal.OnSet === "Unknown"}
                                        />
                                        <label htmlFor="Unknown" className="text ar-orange-text">Unknown</label>
                                    </div>
                                </div> */}
                            </div>
                            {/* <div className="mb-12 d-flex"> */}
                            {/* <div className="form-group input"> */}
                            {/* <div className={`form-group input ${allergiesValidationModal.StatusVal ? 'error' : ''}`}>
                                    <label className="pb-3px">Status <span className='req'>*</span></label>
                                    <div className={'input form-group ar-multiple-br m-0'}>
                                        <SuperSearchList
                                            type="client"
                                            id='AllergyStatus'
                                            name='AllergyStatus'
                                            searchValue={mainAllergiesModal.AllergyStatus}
                                            data={StatusData}
                                            onChange={handleChange}
                                            getSelectedData={handleSelectedData}
                                            is={is}
                                            sup_btn='sup_btn-Inp'
                                            sup_inp='superSearchVisitInp'
                                            placeholder="Select type..."
                                            inputError={allergiesValidationModal.StatusVal}
                                        />
                                    </div>
                                    {allergiesValidationModal.StatusVal}
                                </div>
                            </div> */}
                            <div className="input">
                                <label className="pb-3px">Notes</label>
                                <textarea
                                    rows="2"
                                    name='Notes'
                                    id='Notes'
                                    className="form-control"
                                    onChange={handleChange}
                                    value={mainAllergiesModal.Notes}
                                >
                                </textarea>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <div className="d-flex align-items-center pb-15 px-10 pt-2 br-top-1 za_br_light  ar_footer justify-content-end gap-2">
                <button className='btn btn-outline  px-10 h-100 dark-clr' onClick={onClose}>Cancel</button>
                <button className={`btn btn-outline  px-10 h-100 validate-color ${IsEditAllowed ? '' : 'disable'}`} onClick={() => handleSaveAllergies("Add Another")}>Save & Add Another</button>
                <button className={`btn btn-validate px-10 h-100 ${IsEditAllowed ? '' : 'disable'}`} onClick={handleSaveAllergies}>Save</button>
            </div>
        </Modal>
    )
}

export default AddNewAllergies


{/* <Modal show={adddelete3} onHide={adddelete3} backdrop="static" keyboard={false} centered dialogClassName="hk-modal-v1 ar_ehr_allergies">
<div className="d-flex align-items-center pb-15 px-10 pt-2 br-top-1 br-clr justify-content-end gap-2">
    <button className='btn btn-outline btn-xs no-width rounded-5 px-10'>Clear</button>
    <button className='btn btn-validate btn-xs no-width rounded-5 px-10'>Search</button>
</div>
</Modal> */}